import { AfterContentChecked, Component, OnInit, ChangeDetectorRef, inject, AfterViewChecked } from '@angular/core';
import { ApiService, BlockService, PageService } from '@gallaghercp/core-frontend';
import { ClientService } from '../../services/client.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { APP_CONFIG } from '../../app.config';

@Component({
    selector: 'core-main',
    templateUrl: './main.component.html',
    standalone: false,
})
export class MainComponent implements OnInit, AfterContentChecked, AfterViewChecked {
    protected changeDetectorRef = inject(ChangeDetectorRef);

    containerClass!: string;
    wrapperClass?: string;
    headerClass?: string;
    page: any;
    category?: string | boolean;
    delayedLoaded?: boolean;
    gtm: any;
    fragmentScroll: string | null = '';
    fireScroll = false;

    constructor(
        private router: Router,
        private blocks: BlockService,
        private route: ActivatedRoute,
        private pages: PageService,
        private sanitizer: DomSanitizer,
        private api: ApiService,
        public client: ClientService,
        private changeDetector: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.setContainerClass();
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.setContainerClass();
            }
        });
        if (APP_CONFIG.gtm) {
            this.gtm = this.sanitizer.bypassSecurityTrustResourceUrl(
                'https://www.googletagmanager.com/ns.html?id=' + APP_CONFIG.gtm,
            );
        }
        this.pages.currentPage$!.subscribe(page => {
            this.delayedLoaded = false;
            if (page) {
                this.page = page;
                this.category =
                    this.page.categoryNames && this.page.categoryNames[0]
                        ? this.page.categoryNames[0].toLowerCase().replace(' ', '-')
                        : false;
            }
            setTimeout(() => {
                this.delayedLoaded = true;
                this.changeDetectorRef.detectChanges();
            }, 300);
        });
        this.route.fragment.subscribe((fragment: string | null) => {
            this.fragmentScroll = fragment;
        });
    }

    ngAfterContentChecked() {
        if (!this.fireScroll) {
            if (typeof this.fragmentScroll === 'string') {
                const element: Element | null = document.getElementById(this.fragmentScroll);
                if (element) {
                    setTimeout(() => {
                        const headerOffset = 115;
                        const elementPosition = element.getBoundingClientRect().top;
                        const offsetPosition = elementPosition - headerOffset;
                        window.scrollTo({
                            top: offsetPosition,
                            behavior: 'smooth',
                        });
                        this.fireScroll = true;
                    }, 0);
                }
            }
        }
    }

    ngAfterViewChecked() {
        this.changeDetector.detectChanges();
    }

    private setContainerClass() {
        if (this.api.getServiceZone() === '2') {
            this.containerClass = '';
            this.headerClass = 'cloudacademy cloudacademy__header';
            this.wrapperClass = 'cloudacademy cloudacademy__container';
        } else {
            switch (this.router.url) {
                case '/headlines':
                case '/stories':
                    this.containerClass = 'home-container';
                    this.wrapperClass = 'background-grey';
                    break;
                case '/':
                case '/1':
                case '/default':
                case '/default1':
                case '/preview':
                case '/#whats-new': // Toggle 1 on the homepage
                    this.containerClass = '';
                    this.wrapperClass = 'home-container home-container--section-1';
                    break;
                case '/#my-benefits': // Toggle 2 on the homepage
                    this.containerClass = '';
                    this.wrapperClass = 'home-container home-container--section-2';
                    break;
                case '/benefit-updates':
                    this.containerClass = 'header-spacer page-spacer';
                    this.wrapperClass = 'page-content-wrapper--benefit-updates';
                    break;
                case '/frequently-asked-questions':
                    this.containerClass = 'header-spacer page-spacer';
                    this.wrapperClass = 'page-content-wrapper--faq';
                    break;
                default:
                    this.containerClass = 'header-spacer page-spacer';
                    this.wrapperClass = 'page-content-wrapper--style1';
                    break;
            }
        }
    }
}
